<div *appRoles="[
'ExpedientesNotas.Crear',
'ExpedientesNotas.Modificar',
'ExpedientesNotas.Eliminar'
]">
<button mat-raised-button color="primary" *ngIf="action === 'Agregar'" [disabled]="disabled" name="Modificar">
  <mat-icon>add</mat-icon> Agregar
</button>
<button mat-raised-button color="primary" *ngIf="action === 'Modificar'" [disabled]="disabled" name="Modificar">
  <mat-icon>save</mat-icon> Guardar
</button>
<button mat-raised-button color="primary" *ngIf="action === 'Eliminar'" [disabled]="disabled" name="Modificar">
  <mat-icon>delete</mat-icon> Eliminar
</button>
</div>
